import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M6.546 28.727v-9.314q2.166-.989 4.848-.989c1.169 0 1.973.213 3.727.87 1.882.707 2.795.948 4.152.948q2.636-.002 5.662-1.29a3.03 3.03 0 0 0 1.815-2.377q.402-2.924.402-6.636c0-2.576-.145-4.584-.438-6.035a1.212 1.212 0 0 0-1.695-.86c-2.092.963-4.007 1.44-5.746 1.44-1.169 0-1.973-.212-3.727-.87-1.883-.706-2.795-.947-4.152-.947q-2.088 0-3.912.554a3.03 3.03 0 0 0-2.149 2.9v22.606a.606.606 0 0 0 1.212 0m9-10.567c-1.883-.706-2.795-.948-4.152-.948q-2.635 0-4.849.883V6.12c0-.8.524-1.507 1.29-1.74q1.647-.501 3.559-.501c1.169 0 1.973.213 3.727.87 1.882.706 2.795.948 4.152.948q2.891-.002 6.253-1.553c.274 1.358.413 3.293.413 5.795q0 3.634-.39 6.471a1.82 1.82 0 0 1-1.089 1.426q-2.813 1.195-5.187 1.194c-1.169 0-1.973-.213-3.727-.87",
      clipRule: "evenodd"
    }
  )
);
var SvgBannerOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var BannerOutlined_default = SvgBannerOutlined;

export { BannerOutlined_default as default };
